import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect
} from 'react-router-dom'

import Home from '../pages/Home'
import Login from '../pages/Login'
import CadastrarUsuario from '../pages/CadastrarUsuario'
import BuscarEntidades from '../pages/BuscarEntidades'
import DadosEcossistema from '../pages/DadosEcossistema'
import Visualizar from '../pages/Visualizar'
import CadastrarEntidade from '../pages/CadastrarEntidade'
import Header from '../components/Header'
import Footer from '../components/Footer'
import MeuPerfil from '../pages/MeuPerfil'
import MinhasEmpresas from '../pages/MinhasEmpresas'
import EditarEntidade from '../pages/EditarEntidade'

const Routes = () => {
    return (
        <Router>
            <Header />
            <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/login" component={Login} />
                <Route path="/cadastrar-usuario" component={CadastrarUsuario} />
                <Route path="/buscar" component={BuscarEntidades} />
                <Route path="/visualizar/:id" component={Visualizar} />
                <Route path="/dados-ecossistema" component={DadosEcossistema} />
                <Route path="/cadastrar" component={CadastrarEntidade} />
                <Route path="/perfil" component={MeuPerfil} />
                <Route path="/MinhasEmpresas" component={MinhasEmpresas} />
                <Route path="/EditarEntidade" component={EditarEntidade} />
                <Redirect from="*" to="/" />
            </Switch>
            <Footer />
        </Router>
    )
}
export default Routes
